"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEnvPublic = void 0;
const log_1 = require("../helpers/log");
function prefixKey(key) {
    // Check if key is available in process.env.
    if (!process.env[key]) {
        (0, log_1.warn)(`Skipped prefixing environment variable '${key}'. Variable not in process.env`);
        return;
    }
    // Check if key is already public.
    if (/^NEXT_PUBLIC_/i.test(key)) {
        (0, log_1.warn)(`Environment variable '${key}' is already public`);
    }
    const prefixedKey = `NEXT_PUBLIC_${key}`;
    process.env[prefixedKey] = process.env[key];
    // eslint-disable-next-line no-console
    (0, log_1.event)(`Prefixed environment variable '${key}'`);
}
/**
 * Make a private environment variable public, so that it can be accessed in the
 * browser.
 *
 * Usage:
 * ```ts
 * // Make a single variable public.
 * makeEnvPublic('FOO');
 *
 * // Make multiple variables public.
 * makeEnvPublic(['FOO', 'BAR', 'BAZ']);
 * ```
 */
function makeEnvPublic(key) {
    if (typeof key === 'string') {
        prefixKey(key);
    }
    else {
        key.forEach(prefixKey);
    }
}
exports.makeEnvPublic = makeEnvPublic;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFrZS1lbnYtcHVibGljLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL21ha2UtZW52LXB1YmxpYy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx3Q0FBNkM7QUFFN0MsU0FBUyxTQUFTLENBQUMsR0FBVztJQUM1Qiw0Q0FBNEM7SUFDNUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLEVBQUU7UUFDckIsSUFBQSxVQUFJLEVBQ0YsMkNBQTJDLEdBQUcsZ0NBQWdDLENBQy9FLENBQUM7UUFFRixPQUFPO0tBQ1I7SUFFRCxrQ0FBa0M7SUFDbEMsSUFBSSxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUU7UUFDOUIsSUFBQSxVQUFJLEVBQUMseUJBQXlCLEdBQUcscUJBQXFCLENBQUMsQ0FBQztLQUN6RDtJQUVELE1BQU0sV0FBVyxHQUFHLGVBQWUsR0FBRyxFQUFFLENBQUM7SUFFekMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUMsR0FBRyxPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBRTVDLHNDQUFzQztJQUN0QyxJQUFBLFdBQUssRUFBQyxrQ0FBa0MsR0FBRyxHQUFHLENBQUMsQ0FBQztBQUNsRCxDQUFDO0FBRUQ7Ozs7Ozs7Ozs7OztHQVlHO0FBQ0gsU0FBZ0IsYUFBYSxDQUFDLEdBQXNCO0lBQ2xELElBQUksT0FBTyxHQUFHLEtBQUssUUFBUSxFQUFFO1FBQzNCLFNBQVMsQ0FBQyxHQUFHLENBQUMsQ0FBQztLQUNoQjtTQUFNO1FBQ0wsR0FBRyxDQUFDLE9BQU8sQ0FBQyxTQUFTLENBQUMsQ0FBQztLQUN4QjtBQUNILENBQUM7QUFORCxzQ0FNQyJ9